<template>
  <div class="app-container">
    <div class="filter-container">
      <el-input v-model="search.name" placeholder="费项/用户" class="filter-item" style="width: 300px;" @keyup.enter.native="handleFilter"/>
      <el-button v-waves type="primary" class="filter-item" icon="el-icon-search" @click="handleFilter">查询</el-button>
    </div>

    <el-table v-loading="listLoading" :key="tableKey" :data="list" border fit highlight-current-row style="width: 100%;">
      <el-table-column label="费项" align="center" width="200px">
        <template slot-scope="scope">
          <span>{{ scope.row.name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="费用类别" width="200px">
        <template slot-scope="scope">
          <span>{{ scope.row.cate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="费用说明">
        <template slot-scope="scope">
          <span>{{ scope.row.note }}</span>
        </template>
      </el-table-column>
      <el-table-column label="用户" align="center" width="120px">
        <template slot-scope="scope">
          <span>{{ scope.row.user }}</span>
        </template>
      </el-table-column>
      <el-table-column label="时间" align="center" width="140px">
        <template slot-scope="scope">
          <span>{{ scope.row.time }}</span>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination-container right">
      <el-pagination v-show="total > search.size" :current-page="search.page" :page-size="search.size" :total="total" layout="total, prev, pager, next" @current-change="handleCurrentChange"/>
    </div>

  </div>
</template>

<script>
import waves from '@/directive/waves'

const option = {
  status: [{key: '1', val: '可用'}, {key: '0', val: '停用'}]
}

export default {
  name: 'AdminFee',
  directives: {
    waves
  },
  filters: {
    statusFilter(key) {
      let data = option.status.find(row => row.key == key)
      return data.val || '-'
    }
  },
  data() {
    return {
      tableKey: 0,
      list: [],
      total: 0,
      listLoading: true,
      search: {
        page: 1,
        size: 12,
        name: '',
        status: ''
      },
      option: option,
      user: [],
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      const _t = this
      _t.listLoading = true
      _t.$http.post('/api/fee/', _t.search).then(resp => {
        _t.list = resp.data.list
        _t.total = resp.data.total
        setTimeout(() => {
          _t.listLoading = false
        }, 500)
      }).catch(() => {
        setTimeout(() => {
          _t.listLoading = false
        }, 500)
      })
    },
    handleFilter() {
      this.search.page = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.search.page = val
      this.getList()
    }
  }
}
</script>
